import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const SortIcon: FC<PropsT> = ({ fill = 'currentColor' }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.5039 18C13.5039 18.2761 13.7278 18.5 14.0039 18.5C14.28 18.5 14.5039 18.2761 14.5039 18L13.5039 18ZM14.5039 6C14.5039 5.72386 14.28 5.5 14.0039 5.5C13.7278 5.5 13.5039 5.72386 13.5039 6L14.5039 6ZM14.5039 18L14.5039 6L13.5039 6L13.5039 18L14.5039 18Z"
      fill={fill}
    />
    <path 
      d="M17.1777 9.88297C17.373 10.0782 17.6895 10.0782 17.8848 9.88297C18.0801 9.68771 18.0801 9.37113 17.8848 9.17587L17.1777 9.88297ZM14.3554 5.64645C14.1601 5.45119 13.8435 5.45119 13.6483 5.64645C13.453 5.84172 13.453 6.1583 13.6483 6.35356L14.3554 5.64645ZM17.8848 9.17587L14.3554 5.64645L13.6483 6.35356L17.1777 9.88297L17.8848 9.17587Z"
      fill={fill}
    />
    <path
      d="M10.0273 6C10.0273 5.72386 9.80349 5.5 9.52734 5.5C9.2512 5.5 9.02734 5.72386 9.02734 6L10.0273 6ZM9.02734 18C9.02734 18.2761 9.2512 18.5 9.52734 18.5C9.80349 18.5 10.0273 18.2761 10.0273 18L9.02734 18ZM9.02734 6L9.02734 18L10.0273 18L10.0273 6L9.02734 6Z"
      fill={fill}
    />
    <path
      d="M6.35355 14.117C6.15829 13.9218 5.84171 13.9218 5.64645 14.117C5.45118 14.3123 5.45118 14.6289 5.64645 14.8241L6.35355 14.117ZM9.17586 18.3535C9.37112 18.5488 9.6877 18.5488 9.88297 18.3535C10.0782 18.1583 10.0782 17.8417 9.88297 17.6464L9.17586 18.3535ZM5.64645 14.8241L9.17586 18.3535L9.88297 17.6464L6.35355 14.117L5.64645 14.8241Z"
      fill={fill}
    />
  </svg>
);

export default SortIcon;
import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const SortIcon: FC<PropsT> = ({ fill = 'currentColor' }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.5039 18C13.5039 18.2761 13.7278 18.5 14.0039 18.5C14.28 18.5 14.5039 18.2761 14.5039 18L13.5039 18ZM14.5039 6C14.5039 5.72386 14.28 5.5 14.0039 5.5C13.7278 5.5 13.5039 5.72386 13.5039 6L14.5039 6ZM14.5039 18L14.5039 6L13.5039 6L13.5039 18L14.5039 18Z"
      fill={fill}
    />
    <path 
      d="M17.1777 9.88297C17.373 10.0782 17.6895 10.0782 17.8848 9.88297C18.0801 9.68771 18.0801 9.37113 17.8848 9.17587L17.1777 9.88297ZM14.3554 5.64645C14.1601 5.45119 13.8435 5.45119 13.6483 5.64645C13.453 5.84172 13.453 6.1583 13.6483 6.35356L14.3554 5.64645ZM17.8848 9.17587L14.3554 5.64645L13.6483 6.35356L17.1777 9.88297L17.8848 9.17587Z"
      fill={fill}
    />
    <path
      d="M10.0273 6C10.0273 5.72386 9.80349 5.5 9.52734 5.5C9.2512 5.5 9.02734 5.72386 9.02734 6L10.0273 6ZM9.02734 18C9.02734 18.2761 9.2512 18.5 9.52734 18.5C9.80349 18.5 10.0273 18.2761 10.0273 18L9.02734 18ZM9.02734 6L9.02734 18L10.0273 18L10.0273 6L9.02734 6Z"
      fill={fill}
    />
    <path
      d="M6.35355 14.117C6.15829 13.9218 5.84171 13.9218 5.64645 14.117C5.45118 14.3123 5.45118 14.6289 5.64645 14.8241L6.35355 14.117ZM9.17586 18.3535C9.37112 18.5488 9.6877 18.5488 9.88297 18.3535C10.0782 18.1583 10.0782 17.8417 9.88297 17.6464L9.17586 18.3535ZM5.64645 14.8241L9.17586 18.3535L9.88297 17.6464L6.35355 14.117L5.64645 14.8241Z"
      fill={fill}
    />
  </svg>
);

export default SortIcon;
